import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { LMBackToTop } from '@/utils/display';
import TemplateLoader from '@/loaders/TemplateLoader';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import '@/styles/components/to-top.scss';

interface LayoutProps {
    iframe?: boolean;
    postType?: string;
    slug?: string;
}
const Layout: React.FC<LayoutProps> = ( { iframe = false, postType: propPostType = '', slug: propSlug = '' } ) => {
    const location = useLocation();
    const { postType: paramPostType, slug: paramSlug } = useParams();
    const finalPostType: string = propPostType || paramPostType || '';
    const finalSlug: string = propSlug || paramSlug || '';
    const finalIframe: boolean = iframe || false;
    const [ mainElementClasses, setMainElementClasses ] = useState<string>( '' );

    const layoutClasses = ( classes: Array<string> ) => {
        if ( finalIframe ) {
            classes.push( 'iframe' );
        }
        setMainElementClasses( classes.join( ' ' ) );
    }
    
    useEffect( () => {
        new LMBackToTop();
    }, [] );

    return (
        <>
            { iframe ? 
                <main id="content" className={ mainElementClasses }>
                    <TemplateLoader 
                        key={ location.key }
                        layoutClassesFunction={ layoutClasses }
                        postType={ finalPostType } 
                        queryString={ window.location.search.replace( '?', '' ) }
                        slug={ finalSlug } />
                </main>
            : <>
                <Header />
                <main id="content" className={ mainElementClasses }>
                    <TemplateLoader 
                        key={ location.key }
                        layoutClassesFunction={ layoutClasses }
                        postType={ finalPostType } 
                        queryString={ window.location.search.replace( '?', '' ) }
                        slug={ finalSlug } />
                </main>
                <Footer />
            </> }
        </>
    )
};
export default Layout;